import styles from '../../features/users/styles/users.module.scss';

interface ErrorMessageProps {
  message: string;
}

export const ErrorMessage = ({ message }: ErrorMessageProps) => {
  return (
    <span className={styles["formusers__requerid"]}>
      <p>{message}</p>
    </span>
  )
}
